// Reconstructed from production code; original paths and local names were not available.
import { AppLoading } from "../components/AppLoading.jsx";
import { Link } from "react-router-dom";
import { MEDIA_BASE_URL } from "../services/config.js";
import { PartnersStrip } from "../components/PartnersStrip.jsx";
import { ProductCard } from "../components/ProductCard.jsx";
import React from "react";
import { Seo } from "../components/Seo.jsx";
import { api } from "../services/api.js";
import { canonicalUrl } from "../utils/seo.js";
import { hasUnknownQueryParams } from "../utils/seo.js";
import * as jsxRuntime from "react/jsx-runtime";
import { siteOrigin } from "../utils/seo.js";
import { useLanguage } from "../context/LanguageContext.jsx";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { useTheme } from "../context/ThemeContext.jsx";
const categoryMediaUrl = (l) =>
  l ? (l.startsWith("http") ? l : `${MEDIA_BASE_URL}${l}`) : "";
const CATEGORY_PAGE_SIZE = 12;
const pricePresets = [
  {
    label: "0 - 100 OMR",
    min: "0",
    max: "100",
  },
  {
    label: "100 - 300 OMR",
    min: "100",
    max: "300",
  },
  {
    label: "300 - 700 OMR",
    min: "300",
    max: "700",
  },
  {
    label: "+700 OMR",
    min: "700",
    max: "",
  },
];
function parsePrice(l) {
  if (l == null || l === "") return null;
  const i = Number(l);
  return Number.isFinite(i) && i >= 0 ? i : null;
}
function formatPrice(l) {
  const i = Number(l || 0);
  return `${i.toFixed(i % 1 === 0 ? 0 : 2)} OMR`;
}
function CategoryLoading({ language: language, brand: brand }) {
  return (
    <AppLoading
      variant={"page"}
      layout={"catalog"}
      brand={brand}
      label={
        language === "ar"
          ? "نجهّز التصنيف والمنتجات…"
          : "Preparing this collection…"
      }
      detail={
        language === "ar"
          ? "يتم ترتيب الفلاتر والمنتجات المناسبة."
          : "Getting filters and products ready for you."
      }
    />
  );
}
function CategorySkeleton({ count: l = 8 }) {
  return (
    <div className={"category-product-skeleton-grid"} aria-hidden={"true"}>
      {Array.from({
        length: l,
      }).map((i, c) => (
        <div className={"category-product-skeleton-card"} key={c}>
          <div className={"category-product-skeleton-img"} />
          <div className={"category-product-skeleton-body"}>
            <span />
            <strong />
            <p />
            <em />
          </div>
        </div>
      ))}
    </div>
  );
}
function CategoryPage() {
  const { slug: slug } = useParams(),
    i = useNavigate(),
    c = useLocation(),
    { theme: theme } = useTheme(),
    { language: language, t: t, tProd: tProd, tText } = useLanguage(),
    y = theme?.site_name || "MyShop",
    g = siteOrigin(),
    p = canonicalUrl(g, c.pathname),
    b = hasUnknownQueryParams(c.search, ["sub"]),
    x = language === "ar" ? "تصنيف المنتجات" : "Product category",
    O =
      language === "ar"
        ? "تصفح المنتجات حسب التصنيف والخيارات المتاحة."
        : "Browse products and available options in this collection.",
    [H, E] = useSearchParams(),
    M = H.get("sub"),
    N = H.get("minPrice") || "",
    T = H.get("maxPrice") || "",
    [Y, $] = React.useState(null),
    [I, K] = React.useState(null),
    [J, Q] = React.useState([]),
    [W, te] = React.useState(N),
    [oe, he] = React.useState(T),
    [be, fe] = React.useState(false),
    [pe, ye] = React.useState(true),
    [R, B] = React.useState(false),
    [F, re] = React.useState(""),
    [ge, j] = React.useState(true),
    [A, X] = React.useState(""),
    q = React.useRef(null),
    Z = React.useRef(0),
    ee = React.useRef(false),
    ie = React.useRef(true),
    Ce = React.useRef(0);
  React.useEffect(() => {
    (async () => {
      try {
        ye(true);
        X("");
        const Te = (await api.get("/categories")).data.find(
          (ke) => ke.slug === slug,
        );
        if (!Te) {
          $(null);
          X(tText("Category not found."));
          return;
        }
        $(Te);
      } catch (Me) {
        console.error(Me);
        X(Me.response?.data?.message || Me.message || tText("Unable to load category"));
      } finally {
        ye(false);
      }
    })();
  }, [slug]);
  const _e = React.useMemo(() => Y?.subcategories || [], [Y]);
  React.useEffect(() => {
    te(N);
    he(T);
  }, [N, T]);
  React.useEffect(() => {
    if (!Y) return;
    if (!M) {
      K(null);
      return;
    }
    const le = _e.find((Me) => Me.slug === M);
    K(le ? le.id : null);
  }, [Y, M, _e]);
  const ut = (le) => {
      K(le);
      E(
        (Me) => {
          const Te = new URLSearchParams(Me);
          if (!le) {
            Te.delete("sub");
            return Te;
          }
          const ke = _e.find((Ke) => Ke.id === le);
          ke && Te.set("sub", ke.slug);
          return Te;
        },
        {
          replace: true,
        },
      );
    },
    gt = (le = W, Me = oe) => {
      let Te = parsePrice(le),
        ke = parsePrice(Me);
      Te !== null && ke !== null && Te > ke && ([Te, ke] = [ke, Te]);
      te(Te !== null ? String(Te) : "");
      he(ke !== null ? String(ke) : "");
      E(
        (Ke) => {
          const Et = new URLSearchParams(Ke);
          Te !== null ? Et.set("minPrice", String(Te)) : Et.delete("minPrice");
          ke !== null ? Et.set("maxPrice", String(ke)) : Et.delete("maxPrice");
          return Et;
        },
        {
          replace: true,
        },
      );
    },
    At = () => {
      te("");
      he("");
      E(
        (le) => {
          const Me = new URLSearchParams(le);
          Me.delete("minPrice");
          Me.delete("maxPrice");
          return Me;
        },
        {
          replace: true,
        },
      );
    },
    ce = React.useMemo(() => !!(M && _e.some((le) => le.slug === M)), [M, _e]),
    Ee = React.useCallback(
      async (le = false) => {
        if (!Y?.id || ee.current || (!ie.current && !le)) return;
        const Me = Ce.current,
          Te = le ? 0 : Z.current,
          ke = {
            categoryId: Y.id,
            limit: CATEGORY_PAGE_SIZE,
            offset: Te,
          };
        I && (ke.subcategoryId = I);
        N && (ke.minPrice = N);
        T && (ke.maxPrice = T);
        ee.current = true;
        B(true);
        re("");
        try {
          const Ke = await api.get("/products", {
            params: ke,
          });
          if (Me !== Ce.current) return;
          const Et = Array.isArray(Ke.data) ? Ke.data : [];
          Z.current = Te + Et.length;
          ie.current = Et.length === CATEGORY_PAGE_SIZE;
          j(ie.current);
          Q((Fn) => (le ? Et : [...Fn, ...Et]));
        } catch (Ke) {
          if (Me !== Ce.current) return;
          console.error(Ke);
          re(tText("Unable to load products."));
        } finally {
          Me === Ce.current && ((ee.current = false), B(false));
        }
      },
      [Y?.id, I, N, T],
    );
  if (
    (React.useEffect(() => {
      Y?.id &&
        ((M && ce && I === null) ||
          ((Ce.current += 1),
          (ee.current = false),
          (Z.current = 0),
          (ie.current = true),
          Q([]),
          re(""),
          j(true),
          Ee(true)));
    }, [Y?.id, I, ce, M, N, T, Ee]),
    React.useEffect(() => {
      const le = q.current;
      if (!le) return;
      const Me = new IntersectionObserver(
        (Te) => {
          Te[0]?.isIntersecting && Ee();
        },
        {
          rootMargin: "320px 0px",
        },
      );
      Me.observe(le);
      return () => Me.disconnect();
    }, [Ee]),
    pe)
  )
    return (
      <jsxRuntime.Fragment>
        <Seo
          title={x}
          description={O}
          canonicalUrl={p || void 0}
          type={"website"}
          siteName={y}
          language={language}
          noindex={b}
        />
        <CategoryLoading language={language} brand={y} />
      </jsxRuntime.Fragment>
    );
  if (A)
    return (
      <jsxRuntime.Fragment>
        <Seo
          title={x}
          description={O}
          canonicalUrl={p || void 0}
          type={"website"}
          siteName={y}
          language={language}
          noindex={true}
        />
        <div
          className={"page products-page customer-page"}
          style={{
            padding: 20,
          }}
        >
          <p className={"admin-alert-error"}>{A}</p>
          <button className={"btn"} onClick={() => i("/")}>
            {tText("Go Home")}
          </button>
        </div>
      </jsxRuntime.Fragment>
    );
  const Xe = categoryMediaUrl(Y?.image_url),
    xe = I ? _e.find((le) => le.id === I) : null,
    Ie = xe ? `${tProd(Y.name, Y, "name")} - ${tProd(xe.name, xe, "name")}` : tProd(Y.name, Y, "name"),
    wt =
      language === "ar"
        ? `تصفح منتجات ${tProd(Y.name, Y, "name")}${xe ? ` ضمن ${tProd(xe.name, xe, "name")}` : ""} واكتشف الخيارات المتاحة.`
        : `Browse ${tProd(Y.name, Y, "name")} products${xe ? ` in ${tProd(xe.name, xe, "name")}` : ""} and explore the available options.`,
    Qt = parsePrice(N),
    Dt = parsePrice(T),
    fa = Qt !== null || Dt !== null,
    Zn = xe ? `?sub=${xe.slug}` : "",
    yt = b || !!(M && !ce),
    tt = canonicalUrl(g, c.pathname, Zn),
    Ca = [
      {
        "@type": "ListItem",
        position: 1,
        name: t("home"),
        item: canonicalUrl(g, "/"),
      },
      {
        "@type": "ListItem",
        position: 2,
        name: tProd(Y.name, Y, "name"),
        item: canonicalUrl(g, c.pathname),
      },
    ];
  xe &&
    Ca.push({
      "@type": "ListItem",
      position: 3,
      name: tProd(xe.name, xe, "name"),
      item: tt,
    });
  const Kn =
      tt && J.length
        ? {
            "@context": "https://schema.org",
            "@type": "ItemList",
            "@id": `${tt}#product-list`,
            name: Ie,
            numberOfItems: J.length,
            itemListElement: J.slice(0, 12).map((le, Me) => ({
              "@type": "ListItem",
              position: Me + 1,
              item: canonicalUrl(g, `/products/${le.public_slug || le.id}`),
              name: tProd(le.name, le, "name"),
              image:
                categoryMediaUrl(
                  le.image_url ||
                    le.main_image_url ||
                    le.images?.[0]?.image_url,
                ) || void 0,
            })),
          }
        : null,
    Ka = tt
      ? [
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "@id": `${tt}#breadcrumb`,
            itemListElement: Ca,
          },
          {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "@id": `${tt}#collection`,
            name: Ie,
            description: wt,
            url: tt,
            image: Xe || void 0,
            isPartOf: {
              "@id": `${canonicalUrl(g, "/")}#website`,
            },
            breadcrumb: {
              "@id": `${tt}#breadcrumb`,
            },
            mainEntity: Kn
              ? {
                  "@id": `${tt}#product-list`,
                }
              : void 0,
          },
          Kn,
        ].filter(Boolean)
      : [],
    Fa =
      R && J.length === 0
        ? t("loadingProducts")
        : `${J.length} ${J.length === 1 ? t("productsShown") : t("productsShownPlural")}`,
    Nn = `${_e.length} ${_e.length === 1 ? t("subcategoriesLabel") : t("subcategoriesLabelPlural")}`,
    En =
      Qt !== null && Dt !== null
        ? `${formatPrice(Qt)} - ${formatPrice(Dt)}`
        : Qt !== null
          ? `${t("fromPrice")} ${formatPrice(Qt)}`
          : Dt !== null
            ? `${t("toPrice")} ${formatPrice(Dt)}`
            : t("allPrices");
  return (
    <div className={"page products-page category-page customer-page"}>
      <Seo
        title={Ie}
        description={wt}
        image={Xe || null}
        imageAlt={Ie}
        canonicalUrl={tt || void 0}
        type={"website"}
        siteName={y}
        language={language}
        noindex={yt}
        schema={Ka}
      />
      <div className={"category-hero"}>
        <div className={"category-hero-left"}>
          <div className={"breadcrumb"}>
            <Link to={"/"}>{t("home")}</Link>
            <span>{"/"}</span>
            <span>{tProd(Y.name, Y, "name")}</span>
          </div>
          <h1 className={"category-title"}>{tProd(Y.name, Y, "name")}</h1>
          <div className={"category-meta"}>
            <span>{Fa}</span>
            <span>{Nn}</span>
            {xe && <span>{tProd(xe.name, xe, "name")}</span>}
            {fa && <span>{En}</span>}
          </div>
          <div className={"subcat-pills"}>
            <button
              type={"button"}
              className={"subcat-pill" + (I ? "" : " active")}
              onClick={() => ut(null)}
            >
              {t("allCategories")}
            </button>
            {_e.map((le) => (
              <button
                type={"button"}
                className={"subcat-pill" + (I === le.id ? " active" : "")}
                onClick={() => ut(le.id)}
                key={le.id}
              >
                {tProd(le.name, le, "name")}
              </button>
            ))}
          </div>
        </div>
        <div className={"category-hero-right"}>
          {Xe ? (
            <img
              className={"category-hero-img"}
              src={Xe}
              alt={tProd(Y.name, Y, "name")}
              loading={"eager"}
              fetchPriority={"high"}
              decoding={"async"}
            />
          ) : (
            <div className={"category-hero-placeholder"}>
              {Y.name?.slice(0, 2)?.toUpperCase()}
            </div>
          )}
        </div>
      </div>
      <div className={"products-top"}>
        <div className={"products-heading"}>
          <span className={"section-eyebrow"}>
            {xe ? tProd(xe.name, xe, "name") : t("catalog")}
          </span>
          <div className={"products-title-row"}>
            <h2 className={"products-title"}>{t("catalog")}</h2>
            <span className={"products-count-badge"}>{Fa}</span>
          </div>
          <div className={"products-summary-row"}>
            <span>{tProd(Y.name, Y, "name")}</span>
            <span>{Nn}</span>
            {fa && <span>{En}</span>}
          </div>
        </div>
        <form
          className={"category-filter-card"}
          onSubmit={(le) => {
            le.preventDefault();
            gt();
            fe(false);
          }}
        >
          <button
            type={"button"}
            className={"category-mobile-filter-toggle"}
            aria-expanded={be}
            aria-controls={"category-filter-fields"}
            onClick={() => fe((le) => !le)}
          >
            <span className={"category-mobile-filter-toggle-copy"}>
              <small>{language === "ar" ? "اختياراتك" : "Your choices"}</small>
              <strong>
                {language === "ar"
                  ? "فلترة حسب السعر والفئة"
                  : "Filter by price and category"}
              </strong>
            </span>
            <span
              aria-hidden={"true"}
              className={"category-mobile-filter-toggle-icon"}
            >
              {be ? "−" : "+"}
            </span>
          </button>
          <div
            id={"category-filter-fields"}
            className={`category-mobile-filter-fields${be ? " is-open" : ""}`}
          >
            <div className={"category-filter-head"}>
              <span>{t("filtersLabel")}</span>
              {fa && (
                <button
                  type={"button"}
                  onClick={() => {
                    At();
                    fe(false);
                  }}
                >
                  {t("resetFilters")}
                </button>
              )}
            </div>
            <label className={"category-filter-field"}>
              {t("categories")}
              <select
                aria-label={tText("Filter by subcategory")}
                value={I || ""}
                onChange={(le) =>
                  ut(le.target.value ? Number(le.target.value) : null)
                }
              >
                <option value={""}>{t("toutesSubcategories")}</option>
                {_e.map((le) => (
                  <option value={le.id} key={le.id}>
                    {tProd(le.name, le, "name")}
                  </option>
                ))}
              </select>
            </label>
            <div className={"category-price-filter"}>
              <label className={"category-filter-field"}>
                {t("minPrice")}
                <input
                  type={"number"}
                  min={"0"}
                  step={"0.01"}
                  inputMode={"decimal"}
                  placeholder={"0"}
                  value={W}
                  onChange={(le) => te(le.target.value)}
                />
              </label>
              <label className={"category-filter-field"}>
                {t("maxPrice")}
                <input
                  type={"number"}
                  min={"0"}
                  step={"0.01"}
                  inputMode={"decimal"}
                  placeholder={"7000"}
                  value={oe}
                  onChange={(le) => he(le.target.value)}
                />
              </label>
            </div>
            <div
              className={"category-price-presets"}
              aria-label={tText("Quick price filters")}
            >
              {pricePresets.map((le) => {
                const Me =
                  String(Qt ?? "") === le.min && String(Dt ?? "") === le.max;
                return (
                  <button
                    type={"button"}
                    className={Me ? "active" : ""}
                    onClick={() => {
                      gt(le.min, le.max);
                      fe(false);
                    }}
                    key={le.label}
                  >
                    {le.label}
                  </button>
                );
              })}
            </div>
            <button className={"category-filter-submit"} type={"submit"}>
              {t("applyFilters")}
            </button>
          </div>
        </form>
      </div>
      {(xe || fa) && (
        <div className={"category-active-filters"}>
          <span>{t("activeFilters")}</span>
          {xe && (
            <button type={"button"} onClick={() => ut(null)}>
              {tProd(xe.name, xe, "name")} <b aria-hidden={"true"}>{"x"}</b>
            </button>
          )}
          {fa && (
            <button type={"button"} onClick={At}>
              {En} <b aria-hidden={"true"}>{"x"}</b>
            </button>
          )}
        </div>
      )}
      <div className={"category-products-stage"}>
        {R && J.length === 0 ? (
          <CategorySkeleton />
        ) : J.length === 0 && !F ? (
          <p className={"category-products-empty"}>{t("aucunProduit")}</p>
        ) : (
          <div className={"product-grid"}>
            {J.map((le, Me) => (
              <ProductCard product={le} priority={Me < 4} key={le.id} />
            ))}
          </div>
        )}
        {F && (
          <div className={"category-products-status is-error"}>
            <span>{F}</span>
            <button type={"button"} onClick={() => Ee(true)}>
              {t("recharger")}
            </button>
          </div>
        )}
        {R && J.length > 0 && (
          <div className={"category-products-status"}>
            <span className={"category-products-spinner"} />
            <strong>{t("chargementSuivant")}</strong>
          </div>
        )}
        {!ge && J.length > 0 && (
          <p className={"category-products-end"}>{t("finCollection")}</p>
        )}
        <div ref={q} className={"category-products-sentinel"} />
      </div>
      <PartnersStrip />
    </div>
  );
}
export {
  categoryMediaUrl,
  CATEGORY_PAGE_SIZE,
  pricePresets,
  parsePrice,
  formatPrice,
  CategoryLoading,
  CategorySkeleton,
  CategoryPage,
};
